import { LitElement, html } from 'lit-element';

export class PersonJeunessecard extends LitElement {
    
    static get properties() {
        return {
            id: { type: Number },
            firstname: { type: Boolean },
            lastname: { type: Boolean },
            birthday: { type: Boolean },
            email: { type: Boolean },
            phone: { type: Boolean }
        };
    }

    constructor(id, firstname, lastname, email, birthday, phone) {
        super();
        this.id = id;
        this.firstname = firstname;
        this.lastname = lastname;
        this.email = email;
        this.birthday = birthday;
        this.phone = phone;
    }  

    render() {
        return html`
            <div class="form-row">
                ${this.firstname ? 
                html`<div class="col-3 mt-3">
                        <input required type="text" placeholder="*Vorname" class="form-control" name="tx_cart_cart[persons][${this.id}][personFirstname]">
                    </div>` : html``}
                ${this.lastname ?    
                html`<div class="col-3 mt-3">
                        <input required type="text" placeholder="*Nachname" class="form-control" name="tx_cart_cart[persons][${this.id}][personLastname]">
                    </div>` : html``}
                ${this.email ?    
                html`<div class="col-4 mt-3">
                        <input required type="email" placeholder="*E-Mail" class="form-control" name="tx_cart_cart[persons][${this.id}][personEmail]">
                    </div>` : html``}
                ${this.birthday ?    
                    html`<div class="col-3 mt-3">
                        <input required type="text" placeholder="*Geburtsdatum" class="form-control" name="tx_cart_cart[persons][${this.id}][personBirthday]">
                    </div>` : html``}
                ${this.phone ?    
                    html`<div class="col-3 mt-3">
                        <input type="text" placeholder="Telefon" class="form-control" name="tx_cart_cart[persons][${this.id}][personPhone]">
                    </div>` : html``}
            </div>
        `;
    }

}
customElements.define('person-jeunessecard', PersonJeunessecard);